/* Storefront consent -> Shopify Customer Privacy API. No checkout injection. */
(function () {
  'use strict';

  if (window.heartSoilCookiebotBridge) return;
  window.heartSoilCookiebotBridge = true;

  var loading = false;
  var writing = false;
  var retryTimer;
  var retries = 0;
  var lastApplied = '';
  var MAX_RETRIES = 10;

  function isUS(cookiebot) {
    return /^US(?:-|$)/i.test(cookiebot.userCountry || '');
  }

  function desiredConsent() {
    var cb = window.Cookiebot;
    var gpc = navigator.globalPrivacyControl === true;
    var payload = {};

    // GPC is a visitor signal, independent of banner acceptance and geography.
    // Shopify also honors it natively in configured sale/sharing opt-out regions.
    if (gpc) payload.sale_of_data = false;

    if (!cb || !cb.consent) return payload;

    var consent = cb.consent;
    var categories = {
      analytics: consent.statistics === true,
      marketing: consent.marketing === true,
      preferences: consent.preferences === true
    };

    if (isUS(cb) && gpc) {
      // Match Cookiebot's US Do Not Sell configuration: GPC is a full opt-out.
      categories = { analytics: false, marketing: false, preferences: false };
      Object.assign(payload, categories);
    } else if (cb.hasResponse && consent.method === 'explicit') {
      Object.assign(payload, categories);
    } else if (cb.hasResponse) {
      // Preserve a saved refusal even when an older Cookiebot cookie has no
      // explicit method. Never turn automatic/legacy implied consent into grants.
      Object.keys(categories).forEach(function (key) {
        if (!categories[key]) payload[key] = false;
      });
    }

    if (isUS(cb) && payload.marketing === false) payload.sale_of_data = false;
    // Marketing acceptance must not silently reverse an independent Shopify
    // sale/sharing opt-out. This bridge never sets sale_of_data to true.
    return payload;
  }

  function retry() {
    if (retryTimer || retries >= MAX_RETRIES) return;
    retries += 1;
    retryTimer = window.setTimeout(function () {
      retryTimer = null;
      synchronize();
    }, 500);
  }

  function synchronize() {
    if (loading || writing) return;
    var shopify = window.Shopify;
    if (!shopify) {
      retry();
      return;
    }

    var privacy = shopify.customerPrivacy;
    if (!privacy || typeof privacy.setTrackingConsent !== 'function') {
      if (typeof shopify.loadFeatures !== 'function') {
        retry();
        return;
      }
      loading = true;
      try {
        shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
          loading = false;
          if (error || typeof shopify.customerPrivacy?.setTrackingConsent !== 'function') {
            retry();
            return;
          }
          synchronize();
        });
      } catch (error) {
        loading = false;
        retry();
      }
      return;
    }

    // Read Cookiebot again after API loading and after every completed write.
    // An acceptance queued earlier must not overwrite a more recent refusal.
    var payload = desiredConsent();
    var signature = JSON.stringify(payload);
    if (!Object.keys(payload).length || signature === lastApplied) return;

    writing = true;
    try {
      privacy.setTrackingConsent(payload, function (result) {
        writing = false;
        if (result && result.error) {
          retry();
          return;
        }
        lastApplied = signature;
        retries = 0;
        synchronize();
      });
    } catch (error) {
      writing = false;
      retry();
    }
  }

  function onConsentChange() {
    retries = 0;
    synchronize();
  }

  ['CookiebotOnConsentReady', 'CookiebotOnAccept', 'CookiebotOnDecline'].forEach(function (name) {
    window.addEventListener(name, onConsentChange);
  });
  window.addEventListener('pageshow', onConsentChange);

  // The synchronous CMP can resolve a returning visitor before this deferred
  // asset runs. This also preloads Shopify's API for the first interaction.
  synchronize();
})();
